class ApplicationLicenseDetailViewController extends MUIViewController implements LicenseDetailInfoCellDelegate
{
    static newInstance(): ApplicationLicenseDetailViewController {
        let vc = new ApplicationLicenseDetailViewController('application-license-detail-view');
    vc.initWithResource('layout/licenses/ApplicationLicenseDetailView.html');
        return vc;
    }

    private nameLabel:MUILabel = null;
    private distributorDropdown:MUIButton = null;
    private chargeToDistributorSwitch: MUISwitchButton = null;

    tableView:UITableView = null;
    private totalLabel:MUILabel = null;
    private distributorLabel:MUILabel = null;
    private profitLabel:MUILabel = null;

    private detailSegmentedControl:MUISegmentedControl = null;
    private detailTableView:UITableView = null;
    private footerCommentView:MUIView = null;
    private commentTextArea:MUITextArea = null;
    private addCommentButton:MUIButton = null;

    private infoDataSource:LicensesDetailInfoDataSource = null;
    private logDataSource:BusinessLicenseLogDataSource = null;
    private tokenDataSource:LicensesDetailTokenDataSource = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.nameLabel = MUIOutlet(this, "client-lbl", "MUILabel");

        this.distributorDropdown = MUIOutlet( this, "distributor-dd", "MUIButton");
        this.distributorDropdown.setAction(this, function(this:ApplicationLicenseDetailViewController) {
            AppHelper.sharedInstance().showSelectDistributorViewControllerFromView( this.distributorDropdown, this.businessLicense.distributor, this, function(this:ApplicationLicenseDetailViewController, controller:any, object:Distributor){
                this.businessLicense.distributor = object;
                this.businessLicense.distributorName = object?.name;
                this.distributorDropdown.title = object?.name;
            });
        });

        this.chargeToDistributorSwitch = MUIOutlet( this, "switch-btn", "MUISwitchButton" );
        this.chargeToDistributorSwitch.setOnChangeValue( this, function(this:ApplicationLicenseDetailViewController, control:MUISwitchButton, value:boolean){
            this.businessLicense.chargeToDistributor = value;
        });

        this.tableView = MUIOutlet(this,"table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;

        this.totalLabel = MUIOutlet( this, "footer-total-lbl", "MUILabel" );
        this.distributorLabel = MUIOutlet( this, "footer-distributor-lbl", "MUILabel" );
        this.profitLabel = MUIOutlet( this, "footer-profit-lbl", "MUILabel" );

        this.detailSegmentedControl = MUIOutlet( this, "detail-segmented-control", "MUISegmentedControl" );
        this.detailSegmentedControl.setAction( this, function( this:ApplicationLicenseDetailViewController, control:MUISegmentedControl, index:number ){
            this.reloadDetailTableView();
        } );

        this.detailTableView = MUIOutlet(this,"detail-table-view", "UITableView");
        this.footerCommentView = MUIOutlet( this, "footer-comment-container", "MUIView" );
        this.commentTextArea = MUIOutlet( this, "comments-ta", "MUITextArea" );
        this.addCommentButton = MUIOutlet( this, "comment-add-log-btn", "MUIButton" );
        this.addCommentButton.setAction( this, this.addCommentAction );

        this.logDataSource = new BusinessLicenseLogDataSource();
        this.logDataSource.initWithTableView( this.detailTableView );

        this.infoDataSource = new LicensesDetailInfoDataSource();
        this.infoDataSource.initWithTableView( this.detailTableView, this );

        this.tokenDataSource = new LicensesDetailTokenDataSource();
        this.tokenDataSource.initWithTableView( this.detailTableView );

        this.detailTableView.dataSource = this.logDataSource;
        this.detailTableView.delegate = this.logDataSource;
    }

    viewWillAppear(animate?){
        super.viewWillAppear(animate);
        this.updateUI();
    }

    private businessLicense:BusinessLicense = null;
    set item(item:BusinessLicense) {
        this.businessLicense = item;
        this.updateUI();
    }

    private updateUI(){
        if(this.viewIsLoaded == false || this.businessLicense == null) return;

        this.nameLabel.text = this.businessLicense.client.name;
        this.distributorDropdown.title = this.businessLicense.distributorName;
        this.chargeToDistributorSwitch.on = this.businessLicense.chargeToDistributor;
        this.logDataSource.item = this.businessLicense;
        this.infoDataSource.business = this.businessLicense;

        this.fetchedResultsController = null;
        this.updateTotals();
        this.tableView.reloadData();
    }

    private statusFilter:number = 0;
    setStatusFilter(value:number){
        this.statusFilter = value;
        this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    private reloadDetailTableView() {
        switch( this.detailSegmentedControl.selectedSegmentedIndex ) {
            case 0:
                this.detailTableView.dataSource = this.logDataSource;
                this.detailTableView.delegate = this.logDataSource;
                this.logDataSource.fetchedResultsController = null;
                this.footerCommentView.hidden = false;
                break;
            case 1:
                this.detailTableView.dataSource = this.infoDataSource;
                this.detailTableView.delegate = this.infoDataSource as any;
                this.footerCommentView.hidden = true;
                break;
            case 2:
                this.detailTableView.dataSource = this.tokenDataSource;
                this.detailTableView.delegate = this.tokenDataSource;
                this.tokenDataSource.fetchedResultsController = null;
                this.footerCommentView.hidden = true;
                break;
        }

        this.detailTableView.reloadData();
    }

    // Applications table

    numberOfSections(tableview:UITableView){
        return this.fetchedResultsController.sections.length;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        let sec = this.fetchedResultsController.sections[section];
        return sec.numberOfObjects();
    }

    viewForHeaderInSection(tableView:UITableView, section:number) : MUIView {
        let lbl = new MUILabel();
        lbl.init();
        lbl.text = section == 0 ? null : "INACTIVE";
        return lbl;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as License;

        let cell = tableview.dequeueReusableCellWithIdentifier("LicenseDetailCell") as LicenseDetailCell;
        cell.item = item;
        cell.selected = (item == this.selectedItem);

        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.fetchedResultsController.objectAtIndexPath(indexPath) as License;

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            this.deleteLicense( item );
        }
    }

    selectedItem:License = null;
    didSelectCellAtIndexPath(tableView,indexPath:MIOIndexPath){
        this.selectedItem = this.fetchedResultsController.objectAtIndexPath(indexPath) as License;
        this.didSelectLicense(this.selectedItem);
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null) return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName("License");
        fetchRequest.sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey("active", false), MIOSortDescriptor.sortDescriptorWithKey("product.name", true)];

        let predicateFormat = "deletedAt = null and business.identifier == " + this.businessLicense.identifier;
        switch (this.statusFilter) {
            case 1: predicateFormat += " and active == true"; break;
            case 2: predicateFormat += " and expirationDate < '" + MIODateGetDateString(new Date()) + "'"; break;
            case 3: predicateFormat += " and active == false"; break;
        }
        fetchRequest.predicate = MIOPredicate.predicateWithFormat(predicateFormat);
        fetchRequest.relationshipKeyPathsForPrefetching = ["type", "product"];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, "active");
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
    }

    private deleteLicense( item:License ){
        this.businessLicense.totalAmount -= item.total;
        this.businessLicense.distributorAmount -= item.distributorFeeValue;

        DBHelper.deleteObjectFromMainContext( item, true );

        this.updateTotals();
    }

    updateTotals(){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.totalLabel.text = ad.currencyFormatter.stringFromNumber( this.businessLicense.totalAmount || 0 );
        this.distributorLabel.text = ad.currencyFormatter.stringFromNumber( this.businessLicense.distributorAmount || 0);
        this.profitLabel.text = ad.currencyFormatter.stringFromNumber( (this.businessLicense.totalAmount || 0) - (this.businessLicense.distributorAmount || 0) );
    }

    private last_distributor_fee:string = null;

    showAddLicenseAction() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("LICENSE","LICENSE"), MIOLocalizeString("ADD_LICENSE", "ADD LICENSE"), MUIAlertViewStyle.Default);

        avc.addComboBoxWithConfigurationHandler(this, function(control:MUIComboBox){
            DBHelper.sharedInstance().addObserverForEntity(avc, 'LicenseProduct', MIOPredicate.predicateWithFormat("deletedAt = null"), [MIOSortDescriptor.sortDescriptorWithKey("name", true)], null, function (objects:LicenseProduct[]) {
                control.removeAllItems();
                let selectedIndex = 0;
                for (let i = 0; i < objects.length; i++){
                    let c = objects[i];
                    let price = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( c.price );
                    control.addItem(c.name + " ( " + price + " )", i);
                }
                control.selectItem(selectedIndex);
            });

            control.setOnChangeAction(this, function(cb:MUIComboBox, value:string){
                let index = parseInt( cb.getSelectedItem() );
                let product = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, index, 'LicenseProduct') as LicenseProduct;
                avc.textFields[0].placeholderText = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( product.price );
            });
        });

        avc.addComboBoxWithConfigurationHandler(this, function(control:MUIComboBox){
            DBHelper.sharedInstance().addObserverForEntity(avc, 'LicenseType', MIOPredicate.predicateWithFormat("deletedAt = null"), [MIOSortDescriptor.sortDescriptorWithKey("name", true)], null, function (objects:LicenseProduct[]) {
                control.removeAllItems();
                let selectedIndex = 0;
                for (let i = 0; i < objects.length; i++){
                    let t = objects[i];
                    control.addItem(t.name, i);
                }
                control.selectItem(selectedIndex);
            });

            control.setOnChangeAction(this, function(cb:MUIComboBox, value:string){
                let index = parseInt( cb.getSelectedItem() );
                let product = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, index, 'LicenseProduct') as LicenseProduct;
                avc.textFields[0].placeholderText = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.stringFromNumber( product.price );
            });
        });

        avc.addTextFieldWithConfigurationHandler(this, function(control:MUITextField){
            control.placeholderText = MIOLocalizeString("PRICE","PRICE");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(control:MUITextField){
            control.placeholderText = MIOLocalizeString("DISCOUNT","DISCOUNT");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:ApplicationLicenseDetailViewController, control:MUITextField){
            control.placeholderText = MIOLocalizeString("QUANTITY","QUANTITY");
            control.text = "1";
        });

        avc.addTextFieldWithConfigurationHandler(this, function(this:ApplicationLicenseDetailViewController, control:MUITextField){
            control.placeholderText = MIOLocalizeString("RESELLER_FEE", "RESELLER FEE");
            if (this.last_distributor_fee != null) control.text = this.last_distributor_fee;
        });

        avc.addTextFieldWithConfigurationHandler(this, function(control:MUITextField){
            control.placeholderText = MIOLocalizeString("START_DATE", "START DATE");
        });

        avc.addTextFieldWithConfigurationHandler(this, function(control:MUITextField){
            control.placeholderText = MIOLocalizeString("END_DATE", "END DATE");
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK","OK"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            let productIndex = parseInt(avc.comboBoxes[0].getSelectedItem());
            let product = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, productIndex, 'LicenseProduct') as LicenseProduct;

            let typeIndex = parseInt(avc.comboBoxes[1].getSelectedItem());
            let type = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, typeIndex, 'LicenseType') as LicenseType;

            let price = avc.textFields[0].text.length > 0 ? (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter.numberFromString(avc.textFields[0].text) : null;
            let discount = avc.textFields[1].text.length > 0 ? avc.textFields[1].text : null;
            let qty = parseInt( avc.textFields[2].text ) ?? 1;
            let resellerFee = avc.textFields[3].text;
            let startDate = avc.textFields[4].text;
            let endDate = avc.textFields[5].text;

            this.last_distributor_fee = resellerFee.length > 0 ? resellerFee : null;

            this.createLicense(qty, product, type, price, discount, resellerFee, startDate, endDate );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL","CANCEL"), MUIAlertActionStyle.Cancel, null, null) );

        avc.addCompletionHandler( this, function(){
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc, 'LicenseProduct');
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc, 'LicenseType');
        });

        this.presentViewController(avc, true);
    }

    private createLicense(qty:number, product:LicenseProduct, type:LicenseType, price:number, discount:string, resellerFee:string, startDate:string, endDate:string) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let start_date = ad.dateTimeFormatter.dateFromString(startDate);
        if (start_date == null) start_date = new Date();
        let end_date = ad.dateTimeFormatter.dateFromString(endDate);

        for (let index = 0; index < qty; index++) {

            let lic = MIOEntityDescription.insertNewObjectForEntityForName( "License", ad.managedObjectContext ) as License;
            lic.product = product;
            lic.active = true;
            lic.startDate = start_date;
            lic.expirationDate = end_date;
            lic.type = type;
            lic.business = this.businessLicense;

            lic.price = price ?? product.price;

            let d = 0;
            if (discount != null) {
                d = discount.valueFromPercentageString( lic.price );
                lic.discountFormat = discount;
            }

            lic.total = lic.price - d;

            lic.distributorFeeFormat = resellerFee;
            lic.distributorFeeValue = resellerFee != null ? resellerFee.valueFromPercentageString( lic.total ) : 0;

            this.businessLicense.totalAmount += lic.total;
            this.businessLicense.distributorAmount += lic.distributorFeeValue;
        }

        DBHelper.saveMainContext();
    }


    showSettingActions() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("OPTIONS","OPTIONS"), MIOLocalizeString("SELECT_ONE_OPTION_BELOW", "SELECT ONE OPTION BELOW"), MUIAlertViewStyle.Default);

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("GENERATE_INVOICE", "GENERATE INVOICE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showInvoiceOptions();
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CHANGE_PRODUCT_FROM_SELECTED_LICENSE", "CHANGE PRODUCT FROM SELECTED LICENSE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.changeProductLicense();
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("GENERATE_TOKEN_FROM_SELECTED_LICENSE", "GENERATE TOKEN FROM SELECTED LICENSE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 6 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle("GENERATE TOKENS FROM DATE", MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 8 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle("REMOVE ALL TOKENS/INSTALLMENTS LICENSE", MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.removeAllTockens();
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("SET_START_DATE", "SET START DATE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 1 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("SET_RENOVATION_DATE", "SET RENOVATION DATE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 2 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("SET_START_&_RENOVATION_DATE", "SET START & RENOVATION DATE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 3 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("UPDATE_TOKENS_PRICE", "UPDATE TOKENS PRICE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( 5 );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle("REGENERATE LICENSE INVOICE", MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showUpdateInvoiceAlert();
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CHANGE_BUSINESS_NAME", "CHANGE BUSINESS NAME"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.showChangeBusinessNameAlert();
        }));

        if (this.businessLicense.authSchema == null || this.businessLicense.authSchema.length == 0) {
            avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("LINK_VENUE", "LINK VENUE"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
                this.showLinkVenueSelector();
            }));
        }

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CHANGE_CLIENT", "CHANGE CLIENT"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            AppHelper.sharedInstance().showSelectClientViewControllerFromView(null, null, true, this, function(controller:SelectViewController, value:Client) {
                this.businessLicense.client = value;
            }, null, null );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("RECALCULE_TOTALS", "RECALCULE TOTALS"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.recalculateTotals();
        }));

        if (this.businessLicense.active) {
            avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("ASSIGN_SEASON_TO_LICENSES", "ASSIGN SEASON TO LICENSES"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
                this.showBusinessSeason();
            }));
        }

        if (this.businessLicense.active) {
            avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DEACTIVATE_CLIENT", "DEACTIVATE CLIENT"), MUIAlertActionStyle.Destructive, this, function(this:ApplicationLicenseDetailViewController){
                this.deactivateClient();
            }));
        }
        else {
            avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("REACTIVATE_CLIENT", "REACTIVATE CLIENT"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
                this.reactivateClient();
            }));
        }

        if ((MUIWebApplication.sharedInstance().delegate as AppDelegate).selectedUser.isAdmin) {

            avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("DELETE_SELECTED_BUSINESS", "DELETE SELECTED BUSINESS"), MUIAlertActionStyle.Destructive, this, function(this:ApplicationLicenseDetailViewController){
                this.deleteBusiness();
            }));
        }

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController( avc, true);
    }

    private deleteBusiness(){

        let avc = new MUIAlertViewController();
        avc.initWithTitle( MIOLocalizeString( "WARNING", "WARNING"), MIOLocalizeString("ARE_YOU_SURE?", "ARE YOU SURE?"), MUIAlertViewStyle.Default );

        avc.addAction( MUIAlertAction.alertActionWithTitle( MIOLocalizeString("DELETE", "DELETE"), MUIAlertActionStyle.Destructive, this, function(this:ApplicationLicenseDetailViewController){
            MIONotificationCenter.defaultCenter().postNotification( "BusinessLicenseDidDelete", this.businessLicense );
            DBHelper.deleteObjectFromMainContext( this.businessLicense, true );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController( avc, true);
    }

    private recalculateTotals() {
        let total = 0
        let fee = 0;

        for ( let index = 0; index < this.fetchedResultsController.fetchedObjects.length; index++ ){
            let lic = this.fetchedResultsController.fetchedObjects[index] as License;
            if ( lic.active == false ) continue;
            total += lic.total;
            fee += lic.distributorFeeValue;
        }

        this.businessLicense.totalAmount = total;
        this.businessLicense.distributorAmount = fee;

        DBHelper.saveMainContext();
    }

    // Cell delegate
    private selectedLicense:License = null;
    didSelectLicense(license:License){
        this.selectedLicense = license;
        this.infoDataSource.item = license;
        this.tokenDataSource.item = license;

        this.reloadDetailTableView();
    }

    didChangePrice(license:License, price:number){
        license.price = price;
        let d = license.discountFormat?.valueFromPercentageString(price) ?? 0;
        this.didChangeTotal(license, price - d);
    }

    didChangeDiscount(license: License, discount: string): void {
        license.discountFormat = discount;
        let d = discount?.valueFromPercentageString(license.price) ?? 0;
        this.didChangeTotal(license, license.price - d);
    }

    didChangeTotal(license:License, total:number){

        this.businessLicense.totalAmount -= license.total;
        this.businessLicense.distributorAmount -= license.distributorFeeValue;

        license.total = total;
        license.distributorFeeValue = license.distributorFeeFormat != null ? license.distributorFeeFormat.valueFromPercentageString( total ) : 0;

        this.businessLicense.totalAmount += license.total;
        this.businessLicense.distributorAmount += license.distributorFeeValue;

        this.updateTotals();
    }

    didChangeFee(license:License, fee:string){
        license.distributorFeeFormat = fee;

        this.businessLicense.distributorAmount -= license.distributorFeeValue;

        license.distributorFeeValue = license.distributorFeeFormat != null ? license.distributorFeeFormat.valueFromPercentageString( license.total ) : 0;

        this.businessLicense.distributorAmount += license.distributorFeeValue;
        this.updateTotals();
    }

    private showInvoiceOptions(){
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("FIRST_INVOICE_OPTIONS", "FIRST INVOICE OPTIONS"), MIOLocalizeString("CHOOSE_WHOM_TO_CHARGE", "CHOOSE WHOM TO CHARGE"), MUIAlertViewStyle.Default);

        avc.addComboBoxWithConfigurationHandler( this, function( comboBox:MUIComboBox ) {
            comboBox.addItem( MIOLocalizeString("CUSTOMER", "CUSTOMER"), 0 );
            comboBox.addItem( MIOLocalizeString("DISTRIBUTOR", "DISTRIBUTOR"), 1 );
        } );

        avc.addTextFieldWithConfigurationHandler( this, function( textField:MUITextField ) {
            textField.placeholderText = MIOLocalizeString( "DATE", "DATE" );
        } );

        avc.addComboBoxWithConfigurationHandler( this, function( comboBox:MUIComboBox ) {
            let predicate = MIOPredicate.predicateWithFormat( "entityNameType = 'LicenseInvoice' and entityType >= 0" );
            let sds = [MIOSortDescriptor.sortDescriptorWithKey("prefix", false)];
            DBHelper.sharedInstance().addObserverForEntity(avc, "NumberSerialSequence", predicate, sds, null, function (objects:NumberSerialSequence[]) {
                comboBox.removeAllItems();
                comboBox.addItem( MIOLocalizeString ("DEFAULT", "DEFAULT" ), -1 );
                for ( let i = 0; i < objects.length; i++ )
                    comboBox.addItem( objects[i].name, i );
            });
        } );


        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString( "OK", "OK" ), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            let chargeToDistributor = parseInt( avc.comboBoxes[0].getSelectedItem() ) == 0 ? false : true;

            let date = (MUIWebApplication.sharedInstance().delegate as AppDelegate).dateFormatter.dateFromString( avc.textFields[0].text );

            let serialIndex = parseInt( avc.comboBoxes[1].getSelectedItem() );
            let serial = DBHelper.sharedInstance().objectAtIndexForEntityObserver(avc, serialIndex, 'NumberSerialSequence') as NumberSerialSequence;

            this.generateInvoice( chargeToDistributor, date, serial );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString( "CANCEL", "CANCEL" ), MUIAlertActionStyle.Cancel, null, null));

        avc.addCompletionHandler(this, function () {
            DBHelper.sharedInstance().removeObserverForChangesInEntity(avc, 'NumberSerialSequence');
        });


        this.presentViewController( avc, true);
    }

    private generateInvoice( chargeToDistributor:boolean, date:Date, numberSerial?:NumberSerialSequence ){

        if ( date == null ) {
            AppHelper.showErrorMessage( this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("INVALID_DATE_PLEASE_ADD_A_VALID_DATE", "INVALID DATE. PLEASE ADD A VALID DATE"));
            return;
        }

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.generateInvoice( this.businessLicense, chargeToDistributor, date, numberSerial, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("ERROR", "ERROR"));
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_INVOICE_WAS_CREATED", "THE INVOICE WAS CREATED"));
        });
    }

    private showDatePicker( tag:number ) {
        let dp = new MUIDatePickerController();
        dp.init();
        dp.delegate = this;
        dp.tag = tag;

        AppHelper.sharedInstance().presentViewController(dp, true);
    }

    didSelectDate(controller:MUIDatePickerController, date:Date){
        switch( controller.tag ) {
            case 4: this.createTokensAndInstallments( date ); break;
            case 5: this.updateTokensPrice( date ); break;
            case 6: this.createTokenFromLicense( date ); break;
            case 8: this.createTokensFromBusiness( date ); break;
            case 7: (this as any).updateInvoice( date ); break;
            case 9: LicenseSeasonActions.start( this, this.businessLicense, [ this.seasonLicense ], date, () => this.reloadSeasonFromServer() ); break;
            case 10: LicenseSeasonActions.end( this, this.businessLicense, [ this.seasonLicense ], date, () => this.reloadSeasonFromServer() ); break;
            default: this.applyDate( date, controller.tag ); break;
        }
    }

    private applyDate( date:Date, tag:number ) {

        let new_date = date;
        new_date.setHours(8);

        for (let index = 0; index < this.fetchedResultsController.fetchedObjects.length; index++) {
            let l = this.fetchedResultsController.fetchedObjects.objectAtIndex( index ) as License;

            switch(tag) {
                case 1: l.startDate       = new_date; break;
                case 2: l.nextRenewalDate = new_date; break;
                case 3:
                    l.startDate = new_date;
                    l.nextRenewalDate = new_date;
                    break;
            }
        }

        this.detailTableView.reloadData();
        this.tableView.reloadData();
    }

    // The name lives here and on the venue in auth. The HQ route renames auth first and
    // only then the licence, so it is the one path a rename may take; saving the
    // attribute through the generic save would leave auth behind.
    private renameBusiness(name:string) {
        if (name.length == 0) return;
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.renameBusinessLicense(this.businessLicense, name, (data:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }
            // Already saved by the server; mirror it locally so the screen updates.
            this.businessLicense.name = data["name"];
        });
    }

    private showLinkVenueSelector() {
        let vc = BusinessVenueSelectViewController.newInstance();
        vc.completionTarget = this;
        vc.completionBlock = this.venueDidSelect;
        vc.modalPresentationStyle = MUIModalPresentationStyle.Popover;
        let pc = vc.popoverPresentationController;
        // Anchored on the client label: the settings button belongs to the container
        // view controller, and this is the header the venue belongs to.
        pc.sourceRect = this.nameLabel.frame;
        pc.sourceView = this.nameLabel;
        this.presentViewController(vc, true);
    }

    private venueDidSelect(venue:any) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.linkBusinessLicenseVenue(this.businessLicense, venue["id"], (data:any, error:string) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error);
                return;
            }
            this.businessLicense.authSchema = data["venueID"];
            this.businessLicense.dbSchema = data["venueID"];
            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("LINKED_TO_VENUE", "LINKED TO VENUE") + " " + data["venueName"]);
        });
    }

    private showChangeBusinessNameAlert() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("OPTIONS","OPTIONS"), MIOLocalizeString("TYPE_THE_NEW_NAME", "TYPE THE NEW NAME"), MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler( this, function(this:ApplicationLicenseDetailViewController, textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString( "NAME", "NAME" );
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            this.renameBusiness( avc.textFields[0].text.trim() );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController( avc, true);
    }

    private createTokensAndInstallments(date:Date){

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.createTokensAndInstallments( this.businessLicense, date, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_RESULT_WAS_OK", "THE RESULT WAS OK"));
        });
    }

    private updateTokensPrice(date:Date){

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.updateTokensPrice( this.businessLicense, date, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_RESULT_WAS_OK", "THE RESULT WAS OK"));
        });
    }

    private showUpdateInvoiceAlert() {
        let avc = new MUIAlertViewController();
        avc.initWithTitle("OPTIONS", "FILL THE INFO", MUIAlertViewStyle.Default);

        avc.addTextFieldWithConfigurationHandler( this, function(this:ApplicationLicenseDetailViewController, textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("INVOICE_NUMBER", "INVOICE NUMBER");
        });

        avc.addTextFieldWithConfigurationHandler( this, function(this:ApplicationLicenseDetailViewController, textField:MUITextField) {
            textField.placeholderText = MIOLocalizeString("TOKEN_START_DATE", "TOKEN START DATE");
        });

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("OK", "OK"), MUIAlertActionStyle.Default, this, function(this:ApplicationLicenseDetailViewController){
            let doc_number = avc.textFields[0].text;
            let token_date = avc.textFields[1].text;
            let date = (MUIWebApplication.sharedInstance().delegate as AppDelegate).dateFormatter.dateFromString( token_date );
            this.regenerate_invoice( doc_number, date );
        }));

        avc.addAction( MUIAlertAction.alertActionWithTitle(MIOLocalizeString("CANCEL", "CANCEL"), MUIAlertActionStyle.Cancel, null, null));

        this.presentViewController( avc, true);
    }

    private regenerate_invoice(invoice_number:string, date:Date){

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.regenerateInvoice( invoice_number, this.businessLicense, date, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_RESULT_WAS_OK", "THE RESULT WAS OK"));
        });
    }

    private createTokenFromLicense( date: Date ) {
        if (this.selectedItem == null) return;
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.createTokenFromLicense( this.selectedItem, date, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_RESULT_WAS_OK", "THE RESULT WAS OK"));
        } );
    }

    private createTokensFromBusiness( date: Date ) {
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        ad.webService.createTokensFromBusiness( this.businessLicense, date, (data:any, error:any) => {
            if (error != null) {
                AppHelper.showErrorMessage(this, MIOLocalizeString("ERROR", "ERROR"), error );
                return;
            }

            AppHelper.showInfoMessage(this, MIOLocalizeString("INFO", "INFO"), MIOLocalizeString("THE_RESULT_WAS_OK", "THE RESULT WAS OK"));
        } );
    }

    private changeProductLicense() {
        let vc = AppHelper.sharedInstance().selectViewController("LicenseProduct", "name", false, false, null, this) as SelectEntityViewController;
        vc.allowSearch = true;

        this.presentViewController( vc, true);
    }

    fetchRequestForController(controller:SelectEntityViewController):MIOFetchRequest{

        if (controller.identifier == "LicenseProduct"){
            let sd = [MIOSortDescriptor.sortDescriptorWithKey("name", true)];
            let fetchRequest = MIOFetchRequest.fetchRequestWithEntityName( "LicenseProduct" );
            fetchRequest.sortDescriptors = sd;
            return fetchRequest;
        }
    }

    didSelectObjectFromSelectViewController(controller:SelectEntityViewController, item:MIOManagedObject){

        if (controller.identifier == "LicenseProduct") {
            let object = item as LicenseProduct;
            this.selectedLicense.product = object;
        }

        return true;
    }

    private removeAllTockens() {

        DBHelper.queryObjectsWithCompletion( "LicenseToken", null, MIOPredicate.predicateWithFormat( "license.identifier == " + this.selectedItem.identifier ), ["installment"], this, function(this:ApplicationLicenseDetailViewController, objects:LicenseToken[]){

            for (let obj of objects) {
                DBHelper.deleteObjectFromMainContext( obj, false );
            }

            DBHelper.saveMainContext();
        } );
    }

    private addCommentAction() {
        if ( this.commentTextArea.text.trim().length == 0 ) return;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let log = MIOEntityDescription.insertNewObjectForEntityForName( "BusinessLog", ad.managedObjectContext ) as BusinessLog;

        log.business = this.businessLicense;
        log.user = ad.selectedUser;
        log.userName = ad.selectedUser.name;
        log.date = new Date();
        log.message = this.commentTextArea.text;

        DBHelper.saveMainContext();

        this.commentTextArea.text = null;
    }

    private deactivateClient() {
        let vc = LeaveReasonViewController.newInstance()
        vc.business = this.businessLicense;
        this.presentViewController( vc, true );
    }

    private reactivateClient() {
        let vc = ReactivateReasonViewController.newInstance()
        vc.business = this.businessLicense;
        this.presentViewController( vc, true );
    }

    //
    // Seasonal licences: paid only while their season is open, and nobody knows when it
    // starts until the venue calls. START and END are moved by hand from the licence card;
    // off season the licence stays active, it only stops renewing.
    //

    didChangeSeasonal( license:License, seasonal:boolean ) : boolean {
        // Off season the licence has no renewal date: unmarked now, it would never renew again
        if (seasonal == false && license.offSeason) {
            AppHelper.showErrorMessage( this, MIOLocalizeString("ERROR", "ERROR"), MIOLocalizeString("START_THE_SEASON_BEFORE_UNMARKING_IT", "START THE SEASON BEFORE UNMARKING THE LICENSE AS SEASONAL") );
            return false;
        }
        // Marked while it is working: its season is open, END SEASON closes it
        license.seasonal = seasonal;
        license.offSeason = false;
        return true;
    }

    // The months it works, with check marks: what the licence reports estimate its monthly revenue with
    didSelectSeasonMonths( license:License, sourceView:MUIView, changed:() => void ) {
        let vc = SeasonMonthsSelectViewController.newInstance();
        vc.months = license.seasonMonths;
        vc.onChange = ( months:number ) => {
            license.seasonMonths = months;
            changed();
        };
        vc.modalPresentationStyle = MUIModalPresentationStyle.Popover;
        let pc = vc.popoverPresentationController;
        pc.sourceRect = sourceView.frame;
        pc.sourceView = sourceView;
        this.presentViewController( vc, true );
    }

    private seasonLicense:License = null;
    didSelectSeason( license:License ) {
        if (license.seasonal == false || license.active == false) return;
        this.seasonLicense = license;
        // START asks the day the venue opened, END the day it closed
        let tag = license.offSeason ? 9 : 10;

        // The server reads the licence and writes its season: what is on the screen goes first.
        // The manager saves in sync mode, so the completion comes once it is in the database.
        if (license.hasChanges == false) {
            this.showDatePicker( tag );
            return;
        }
        DBHelper.saveMainContextWithCompletion( this, function(this:ApplicationLicenseDetailViewController){
            this.showDatePicker( tag );
        });
    }

    private reloadSeasonFromServer() {
        LicenseSeasonActions.reload( this.businessLicense, () => {
            this.tableView.reloadData();
            this.reloadDetailTableView();
        });
    }

    // The season of every active licence of the business at once
    private showBusinessSeason() {
        let vc = BusinessLicenseSeasonViewController.newInstance();
        vc.business = this.businessLicense;
        vc.onDone = () => this.reloadSeasonFromServer();
        this.presentViewController( vc, true );
    }
}
